import { render } from "./CreditsPopover.vue?vue&type=template&id=1ec4a579&scoped=true"
import script from "./CreditsPopover.vue?vue&type=script&lang=js"
export * from "./CreditsPopover.vue?vue&type=script&lang=js"

import "./CreditsPopover.vue?vue&type=style&index=0&id=1ec4a579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec4a579"]])

export default __exports__